PJQ.views.projects.ProjectDetails = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Details'),
		subTemplates: {
			field: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Details-Core-Field')
		},
		layout: {
			columns: [
				{
					sortOrder: 10,
					fields: [
						{
							field: "projectName",
							classes: "col-12",
							sortOrder: 10
						},
						{
							field: "address1",
							classes: "col-12",
							sortOrder: 20
						},
						{
							field: "address2",
							classes: "col-12",
							sortOrder: 30
						},
						{
							field: "location",
							classes: "col-12",
							sortOrder: 40
						}
					]
				},
				{
					sortOrder: 20,
					fields: [
						{
							field: "bidsDue",
							classes: "col-12",
							sortOrder: 10
						},
						{
							field: "user1",
							classes: "col-12",
							sortOrder: 20
						},
						{
							field: "user2",
							classes: "col-12",
							sortOrder: 30
						}
					]
				},
				{
					field: "notes",
					classes: "col-12",
					sortOrder: 40
				},
				{
					field: "startDate",
					sortOrder: 50
				},
				{
					field: "finishDate",
					sortOrder: 60
				}
			]
		}
	},
	events: {
		'click .btn-project-edit-cancel': 'cancelEdit',
		'click .btn-project-save': 'save',
		'click .btn-push-erp': 'pushERP',
		'click .btn-undo-push-erp': 'undoPushERP',
		'click .btn-link-erp': 'linkERP',
		'click .btn-unlink-erp': 'unlinkERP',
		'click .btn-project-export': 'exportPDF',
		'change .input-project-nda': 'ndaRequiredChanged',
		'click .btn-edit-project-nda': 'editProjectNDA',
		'change .input-details-admin-only': 'detailsAdminOnlyChanged'
	},
	beforeFirstRender: function () {
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_STATUS_ID) &&
			(_.size(_.filter(this.options.layout.columns, function (column) {
				return column.field === "projectStatusId"
			})) === 0)) {
			this.options.layout.columns.push({
				field: "projectStatusId",
				sortOrder: 70
			});
		}

		this.options.canEdit = PJQ.app.session.project.get('masterUserId') === PJQ.app.session.get('masterUserId')
			&& !PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_PROJECT_HOME_READONLY)
			&& PJQ.app.session.project.get('status') !== 'ARCHIVE' && PJQ.app.session.project.hasPermission('base.canEdit');

		this.mergePortalLayout();
		if (this.options.canEdit) {
			if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
				let defs = PJQ.app.portal.customization.project.details.defaults;
				if (defs != null) {
					this.portalDefaults = defs;
					this.triggerPortalDefaults();
				}
			}
		}

		this.options.startEndHide = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.START_END_HIDE);

		this.listenTo(this.model, 'sync', this.render);
		this.listenTo(this.model, 'change', _.bind(function (e) {
			this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', false);
			this.$('.btn-project-export').prop('disabled', true);
		}, this));

		PJQ.app.session.fetchProjectStatuses(_.bind(function(statuses) {
			this.projectStatuses = statuses;

			PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
				this.erpIntegration = erp;
				if(this.erpIntegration != null){
					this.model.fetchERPObject(_.bind(function(){
						this.render();
					}, this));
				}
				else{
					this.render();
				}
			}, this));
		}, this));
		return false;
	},
	renderERP: function () {
		if (this.erpIntegration == null || this.model == null) {
			return;
		}

		let pushSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT),
			linkSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.LINK_PROJECT),
			unlinkSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PROJECT);
		PJQ.helpers.erp.renderERPButtons(this.$('.erp-sync'), {
			pushSupported: pushSupported,
			unlinkSupported: unlinkSupported,
			linkSupported: linkSupported,
			canPush: this.options.canEdit,
			disablePushReason: null,
			status: this.model.erpSyncStatus()
		});
	},
	pushERP: function () {
		if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PROJECT)) {
			return;
		}

		this.save((success) => {
			if (!success) {
				return;
			}

			this.erpIntegration.pushProject(this.model, () => {
				PJQ.notifications.notify.successNotify({
					message: 'Project pushed to ERP'
				});
				this.render();
			});
		});
	},
	undoPushERP: function () {
		if (this.model.erpSyncStatus() !== PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
			return;
		}

		this.erpIntegration.undoPush(this.model, () => {
			PJQ.notifications.notify.successNotify({
				message: 'Project removed from ERP approval'
			});
			this.render();
		});
	},
	linkERP: function () {
		if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.LINK_PROJECT)) {
			return;
		}

		new PJQ.integrations.models.LinkERPProjectModal({
			project: PJQ.app.session.project,
			onSave: _.bind(function (erpProject) {
				if (erpProject.isERPSynced()) {
					this.render();
				}
			}, this)
		});
	},
	unlinkERP: function () {
		if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PROJECT)) {
			return;
		}

		new PJQ.views.modals.YesNo({
			header: "Unlink from ERP",
			body: "Are you sure you want to unlink this Project from your ERP system?",
			onYes: () => {
				let loader = new PJQ.Loader(this.$('.project-details'));
				this.erpIntegration.unlinkProject(this.model, () => {
					loader.remove();
					PJQ.notifications.notify.successNotify({
						message: 'Project unlinked from ERP'
					});
					this.render();
				});
			}
		});
	},
	mergePortalLayout: function () {
		let layout = null;
		if (PJQ.helpers.objectHelpers.checkNested(PJQ.app, 'portal', 'customization', 'project', 'details')) {
			layout = PJQ.app.portal.customization.project.details.layout;
		}

		let findPortalLayoutField = _.bind(function (searchField) {
			let result = null;
			_.each(layout.columns, function (column) {
				if (_.size(column.fields) > 0) {
					result = result || _.find(column.fields, function (field) {
						return field.field === searchField.field;
					});
				} else if (column.field != null && column.field === searchField.field) {
					result = column;
				}
			}, this);
			return result;
		}, this);

		if (layout != null) {
			_.each(this.options.layout.columns, function (column) {
				if (_.size(column.fields) > 0) {
					let col = _.defaults({fields: []}, column);
					_.each(column.fields, function (field) {
						if (findPortalLayoutField(field) == null) {
							col.fields.push(field);
						}
					});
					if (_.size(col.fields) > 0) {
						layout.columns.push(col);
					}
				} else if (column.field != null) {
					if (findPortalLayoutField(column) == null) {
						layout.columns.push(column);
					}
				}
			});
		} else {
			layout = this.options.layout;
		}

		//add custom field columns to template that were not defined in the custom portal details layout
		let nextSort = _.max(layout.columns, function (column) {
			if (_.size(column.fields) > 0) {
				return _.max(column.fields, function (field) {
					return field.sortOrder != null ? field.sortOrder : 0;
				});
			}
			return column.sortOrder != null ? column.sortOrder : 0;
		}).sortOrder;
		_.each(this.model.customFields.models, function (customField) {
			let cfId = 'cf_' + customField.id.toString(),
				cf = {
					field: cfId,
					sortOrder: nextSort
				};
			if (findPortalLayoutField(cf) == null) {
				layout.columns.push(cf);
				nextSort += 10;
			}
		});
		this.options.layout = layout;
	},
	renderData: function () {
		return {
			model: this.model,
			subTemplates: this.options.subTemplates,
			layout: this.options.layout,
			layoutOptions: {
				notesHide: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_HIDDEN),
				isNotesRequired: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_REQUIRED),
				isUser2Required: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_USER_2_REQUIRED),
				isCityRequired: this.isCityRequired(),
				isStateRequired: this.isStateRequired(),
				isZipRequired: this.isZipRequired(),
				isBidDueDateRequired: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED),
				notesLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_NOTES_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_NOTES_LABEL) : 'Notes',
				responseDueLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.RESPONSE_DUE_LABEL) : 'Response Due',
				startDateLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_START_LABEL) : 'Start Date',
				finishDateLabel: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_FINISH_LABEL) : 'Finish Date',
				user1Label: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_1_LABEL) : 'Project Contact',
				user2Label: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_LABEL) : 'Project Contact 2',
				user2Hide: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_USER_2_HIDE),
				startEndHide: this.options.startEndHide
			},
			erpIntegration: this.erpIntegration,
			defaultNDAChecked: PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_NDA_CHECKED_DEFAULT),
			isEdit: this.options.canEdit,
			canExport: this.options.canEdit && PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DETAILS_EXPORT)
		};
	},
	triggerPortalDefaults: function (changedId = null) {
		if (this.portalDefaults == null) {
			return;
		}

		_.each(this.portalDefaults, function (def, id) {
			if ((def.reference != null && changedId == null) || (changedId != null && changedId !== def.reference && changedId !== def.timeReference) || (id === 'bidsDue' && this.model.get('responseDueDate') === 'ASAP')) {
				return;
			}

			let refValue = null,
				timeRefValue = null;
			if (def.reference != null) {
				if (def.reference.indexOf('cf_') !== -1) {
					let refCfId = parseInt(def.reference.replace('cf_', '')),
						refCf = this.model.customFields.get(refCfId),
						refFieldValue = _.findWhere(this.model.get('customFields'), {id: refCfId});
					if (refFieldValue != null) {
						if (refCf.get('fieldType').toLowerCase() === 'choice') {
							let selChoice = refCf.choices.get(refFieldValue.value);
							if (selChoice != null) {
								refValue = selChoice.get('choiceName');
							}
						} else {
							refValue = refFieldValue.value;
						}
					}
				} else {
					refValue = this.model.get(def.reference);
				}
			}

			if (def.timeReference != null) {
				if (def.timeReference.indexOf('cf_') !== -1) {
					let timeRefCfId = parseInt(def.timeReference.replace('cf_', '')),
						timeRefCf = this.model.customFields.get(timeRefCfId),
						timeRefFieldValue = _.findWhere(this.model.get('customFields'), {id: timeRefCfId});
					if (timeRefFieldValue != null) {
						timeRefValue = timeRefFieldValue.value;
					}

					if (timeRefCf.get('fieldType').toLowerCase() === 'choice') {
						let selChoice = timeRefCf.choices.get(timeRefFieldValue.value);
						if (selChoice != null) {
							timeRefValue = selChoice.get('choiceName');
						}
					} else {
						timeRefValue = timeRefFieldValue.value;
					}
				} else {
					timeRefValue = this.model.get(def.reference);
				}
			}

			let newValue = undefined;
			if (def.match != null) {
				let match = def.match[refValue == null ? 'null' : refValue];
				if (typeof match === 'undefined') {
					if (refValue != null && _.size(refValue.toString()) > 0) {
						match = def.match["_notEmpty"];
					} else {
						match = def.match["_empty"];
					}
				}

				if (match != null) {
					if (match.from === 'today') {
						if (def.offset != null && def.offset !== 0) {
							newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), def.offset);
						} else {
							newValue = new Date();
						}
					} else if (typeof match.value !== 'undefined') {
						newValue = match.value;
					}
				}
			} else {
				switch (def.type) {
					case 'DATE':
					case 'DATETIME':
						if (def.offset != null) {
							if (def.reference != null && refValue == null) {
								newValue = null;
							} else {
								if (def.defaultTime != null) {
									let dt = new Date(PJQ.helpers.dateHelpers.getDateString(refValue ? new Date(refValue) : new Date(), PJQ.helpers.dateHelpers.dateFormats.DATE, true) + ' ' + (timeRefValue ? timeRefValue : def.defaultTime));
									newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(dt, def.offset, def.weekdaysOnly === true);
								} else {
									newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(refValue ? new Date(refValue + (timeRefValue ? (' ' + timeRefValue) : '')) : new Date(), def.offset, def.weekdaysOnly === true);
								}

								if (def.minOffset != null && newValue.getTime() < (new Date()).getTime()) {
									newValue = PJQ.helpers.dateHelpers.getNewDateAddDays(new Date(), def.minOffset, def.weekdaysOnly === true);
								}
							}
						} else if (typeof def.value !== 'undefined') {
							newValue = def.value;
						}
						break;
					case 'TEXT':
						newValue = refValue;
						break;
				}
			}

			if (typeof newValue == 'undefined')
				return;

			if (def.type === 'DATE' && newValue != null && id.toLowerCase() !== 'startdate' && id.toLowerCase() !== 'enddate') {
				newValue = PJQ.helpers.dateHelpers.getDateString(newValue, PJQ.helpers.dateHelpers.dateFormats.DATE);
			}

			if (id.indexOf('cf_') !== -1) {
				let cfId = parseInt(id.replace('cf_', '')),
					fieldValue = _.findWhere(this.model.get('customFields'), {id: cfId});

				if (fieldValue.value != null && def.reference == null) {
					return;
				}

				fieldValue.value = newValue;
				if (this.projectCustomFieldsForm) {
					this.projectCustomFieldsForm.setValue(cfId, newValue);
				}
			} else {
				this.model.set(id, newValue);
				if (id.toLowerCase() === 'bidsdue' && this.dueDatePicker != null) {
					this.dueDatePicker.setValue(newValue);
				} else if (id.toLowerCase() === 'startdate' && this.startDatePicker != null) {
					this.startDatePicker.setValue(newValue);
				} else if (id.toLowerCase() === 'enddate' && this.endDatePicker != null) {
					this.endDatePicker.setValue(newValue);
				} else if (this.coreBinder != null) {
					this.coreBinder.setValue(id, newValue);
				}
			}
		}, this);
	},
	afterRender: function () {
		if (this.projectStatuses == null) {
			return;
		}

		this.renderERP();

		this.projectCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
			el: this.$el,
			shouldRenderTemplate: false,
			collection: this.model.customFields,
			fieldValues: this.model.get('customFields'),
			isEdit: this.options.canEdit,
			onChange: _.bind(function (fieldId, value) {
				this.triggerPortalDefaults('cf_' + fieldId.toString());
				this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', false);
				this.$('.btn-project-export').prop('disabled', true);
			}, this)
		});

		this.coreBinder = new PJQ.Binder(this.$('.project-details-form'), this.model, {
			watchElements: [
				'input',
				'textarea'
			]
		});

		let statePicker = new PJQ.inputs.StatePicker({
			el: this.$('select.state'),
			country: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			defaultValue: this.model.get('state') ? this.model.get('state').toUpperCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value);
			}, this)
		});

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.IS_DOCUMENT_CLERK) && this.options.canEdit) {
			new PJQ.inputs.Selectpicker({
				el: this.$('select.project-status'),
				onChange: _.bind(function (value) {
					this.model.set('status', value);
				}, this)
			});
		}

		new PJQ.inputs.CountryPicker({
			el: this.$('select.country'),
			defaultValue: this.model.get('country') ? this.model.get('country').toUpperCase() : null,
			statePicker: statePicker,
			zipInput: this.$('.zip'),
			onChange: _.bind(function (value) {
				this.model.set('country', value);
			}, this)
		});

		if (this.model.get('responseDueDate') === 'ASAP') {
			this.$('.response-due-asap').prop('checked', true);
			this.$('.input-response-due').prop('disabled', true);
		}

		this.$('.response-due-asap').on('click', _.bind(function () {
			if (this.$('.response-due-asap').prop('checked')) {
				this.model.set('bidsDue', null);
				this.model.set('responseDueDate', 'ASAP');
				this.$('.input-response-due').val('').prop('disabled', true);
			} else {
				this.model.set('responseDueDate', '');
				this.$('.input-response-due').prop('disabled', false);
				this.triggerPortalDefaults('bidsdue');
			}
		}, this));

		this.dueDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.input-response-due'),
			datepickerOptions: {
				defaultDate: this.model.get('bidsDue') ? this.model.get('bidsDue') : null
			},
			onChange: _.bind(function (newTime) {
				this.model.set('bidsDue', newTime);
				this.model.set('responseDueDate', PJQ.helpers.dateHelpers.getDateString(this.model.get('bidsDue'), PJQ.helpers.dateHelpers.dateFormats.DATE, false));
				this.triggerPortalDefaults('bidsdue');
			}, this),
			onShow: _.bind(function (context) {
				if (!$(context.datetimepicker).data('DateTimePicker').date() && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME) && PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM)) {
					let tempDate = new Date(),
						timeParts = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME).toString().split(':'),
						hours = parseInt(timeParts[0]), minutes = parseInt(timeParts[1]);
					if (PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM) === 'PM' && hours !== 12 || hours === 12 && PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DEFAULT_BID_DUE_TIME_AMPM) === 'AM')
						hours += 12;
					$(context.datetimepicker).data('DateTimePicker').date(new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate(), hours, minutes, 0, 0));
				}
			}, this)
		});

		if (!this.options.startEndHide) {
			this.startDatePicker = new PJQ.inputs.Datepicker({
				el: this.$('.input-project-start'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: this.model.get('startDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false) : null
				},
				onChange: _.bind(function (newTime) {
					this.model.set('startDate', newTime);
				}, this)
			});

			this.endDatePicker = new PJQ.inputs.Datepicker({
				el: this.$('.input-project-end'),
				datepickerOptions: {
					format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
					defaultDate: this.model.get('endDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false) : null
				},
				onChange: _.bind(function (newTime) {
					this.model.set('endDate', newTime);
				}, this)
			});
		}

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_PROJECT_STATUS_ID)) {
			this.projectStatusIdSelectPicker = new PJQ.inputs.Selectpicker({
				el: this.$('.project-status-id'),
				isIntChoices: true,
				defaultValue: this.model.get('projectStatusId') ? this.model.get('projectStatusId') : PJQ.app.session.projectStatuses.getDefault().id,
				onChange: _.bind(function (value) {
					this.model.set('projectStatusId', value)
				}, this)
			});
		}

		this.userInput = new PJQ.views.contacts.ContactsSelectInput({
			el: this.$('.project-contact'),
			context: PJQ.constants.contacts.contexts.USERS,
			selectedContact: this.model.user,
			isSingleChoice: true,
			emptyNotice: "No User Selected",
			isReadOnly: !this.options.canEdit,
			onAdd: _.bind(function (contacts) {
				this.model.set('user', contacts);
			}, this),
			onDelete: _.bind(function () {
				this.model.set('user', null);
			}, this)
		});

		this.user2Input = new PJQ.views.contacts.ContactsSelectInput({
			el: this.$('.project-contact2'),
			context: PJQ.constants.contacts.contexts.USERS,
			selectedContact: this.model.user2,
			isSingleChoice: true,
			emptyNotice: "No User Selected",
			isReadOnly: !this.options.canEdit,
			onAdd: _.bind(function (contacts) {
				this.model.set('user2', contacts);
			}, this),
			onDelete: _.bind(function () {
				this.model.set('user2', null);
			}, this)
		});

		// show a read-only version of scopes when if they are enabled and a sub is viewing the page.
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_SCOPES) && PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId')) {
			new PJQ.views.projects.ProjectScopes({
				el: this.$('.project-scopes')
			});
		}
	},
	ndaRequiredChanged: function () {
		let hasNDA = this.$('.input-project-nda').prop('checked');
		if (hasNDA) {
			this.editProjectNDA();
		} else {
			this.model.set('hasNDA', false, {
				silent: true
			});
			this.renderNDARequired();
			new PJQ.models.projects.ProjectNDA({
				ndaId: -1,
				project: this.model
			}).destroy({
				success: function () {
					PJQ.notifications.notify.successNotify({
						message: "NDA has been disabled for this project"
					});
				}
			});
		}
	},
	renderNDARequired: function () {
		let hasNDA = this.model.get('hasNDA');
		this.$('.input-project-nda').prop('checked', hasNDA);
		if (hasNDA) {
			this.$('.btn-edit-project-nda').removeClass('hidden');
		} else {
			this.$('.btn-edit-project-nda').addClass('hidden');
		}
	},
	editProjectNDA: function () {
		new PJQ.views.projects.EditProjectNDAModal({
			project: this.model,
			onSave: _.bind(function () {
				this.renderNDARequired();
			}, this),
			onCancel: _.bind(function () {
				this.renderNDARequired();
			}, this)
		});
	},
	detailsAdminOnlyChanged: function () {
		let isDetailsAdminOnly = this.$('.input-details-admin-only').prop('checked');
		this.model.set('isDetailsAdminOnly', isDetailsAdminOnly);
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.model.id
				}
			], [
				{
					parameter: 'isDetailsAdminOnly',
					value: isDetailsAdminOnly
				}
			])
		}).patch().done(_.bind(function () {
			let alertMessage;
			if (isDetailsAdminOnly) {
				alertMessage = "Project details are now hidden from non admins";
			} else {
				alertMessage = "Project details are now visible to non admins";
			}
			PJQ.notifications.notify.successNotify({
				message: alertMessage
			});
		}, this));
	},
	exportPDF: function () {
		// old export
		// PanteraScript.PanteraScriptService.GenerateExportNew(PJQ.app.session.id, 'project', 'pdf', parseInt(PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_DETAILS_EXPORT)), '', function(response) {
		// 	let rr = jQuery.parseJSON(response);
		// 	PJQ.files.downloadFile(rr.DownloadURL, {
		// 		isEndpoint: false
		// 	});
		// }, null);

		// New JSReport Export
		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.model.get('projectId')
				},
				{
					endpoint: 'details'
				},
				{
					endpoint: 'export'
				}
			], [
				{
					parameter: 'timeZone',
					value: Intl.DateTimeFormat().resolvedOptions().timeZone
				}
			]),
			data: {}
		}).post().done(function (response) {
			PJQ.files.handleDownload(response);
		});
	},
	cancelEdit: function () {
		if (this.model.get('status') === 'NEW') {
			PJQ.app.router.navigate('projects', {
				trigger: true,
				replace: true
			});
		} else {
			this.model.fetch();
			this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', true);
			this.$('.btn-project-export').prop('disabled', false);
		}
	},
	save: function (callback = null) {
		let errors = false;

		PJQ.helpers.inputHelpers.setInputError(this.$('.project-name'), true);
		if (this.model.get('projectName').trim().length === 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.project-name'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-response-due'), true);
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_BID_DUE_DATE_REQUIRED) && this.model.get('bidsDue') === null && !this.$('.response-due-asap').prop('checked')) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-response-due'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.city'), true);
		if (this.isCityRequired() && this.model.get('city').trim().length === 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.city'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('select.state'), true);
		if (this.isStateRequired() && this.model.get('state').trim().length === 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('select.state'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.zip'), true);
		if (this.isZipRequired() && this.model.get('zip').trim().length === 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.zip'), false);
			errors = true;
		}

		if (!this.userInput.validate()) {
			errors = true;
		}

		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_USER_2_REQUIRED)) {
			if (!this.user2Input.validate()) {
				errors = true;
			}
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-start'), true);
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.REQUIRE_PROJECT_START_FINISH) && !this.model.get('startDate')) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-start'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-end'), true);
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.REQUIRE_PROJECT_START_FINISH) && !this.model.get('endDate')) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-project-end'), false);
			errors = true;
		}

		PJQ.helpers.inputHelpers.setInputError(this.$('.project-notes'), true);
		if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_NOTES_REQUIRED) && this.model.get('notes').trim().length === 0) {
			PJQ.helpers.inputHelpers.setInputError(this.$('.project-notes'), false);
			errors = true;
		}

		if (!this.projectCustomFieldsForm.validate())
			errors = true;

		PJQ.helpers.inputHelpers.setInputError(this.$('.project-status-id'), true);
		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_STATUS_NON_DEFAULT_REQUIRED)) {
			_.each(PJQ.app.session.projectStatuses.models, _.bind(function (item) {
				if (item.get('projectStatusId') === this.model.get('projectStatusId') && item.get('isDefault')) {
					PJQ.helpers.inputHelpers.setInputError(this.$('.project-status-id'), false);
					errors = true;
				}
			}, this));
		}


		if (errors) {
			PJQ.notifications.notify.errorNotify({
				message: 'One or more fields are not filled out correctly.  Please review the form.'
			});
			return false;
		}

		this.$('.btn-project-edit-cancel').add('.btn-project-save').prop('disabled', true);
		this.$('.btn-project-export').prop('disabled', false);

		let wasNew = this.model.get('status') === 'NEW';
		this.model.save(null, {
			notify: true,
			success: _.bind(function () {
				if (wasNew) {
					PJQ.app.router.navigate('projects/' + PJQ.app.session.project.id + "/dashboard", {
						trigger: true
					});
				}
				this.renderERP();

				if (typeof callback === 'function') {
					callback(true);
				}
			}, this)
		});
	},
	isCityRequired: function () {
		let prefs = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) : '' +
		PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) : '';

		return prefs != null && prefs.indexOf('[Project.City]') !== -1;
	},
	isStateRequired: function () {
		let prefs = PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PRIVATE_FOLDERS) : '' +
		PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.PROJECT_WALL_DEFAULT_PUBLIC_FOLDERS) : '';

		return prefs != null && prefs.indexOf('[Project.State]') !== -1;
	},
	isZipRequired: function () {
		return PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_WALL_ADMIN_ZIP_REQUIRED);
	}
});

PJQ.views.projects.ProjectMapModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Project-Map'),
		width: '800px',
		minWidth: '800px'
	},
	events: {
		'click .map-recenter': 'mapRecenter'
	},
	beforeModalCreated: function () {
		this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
	},
	beforeRender: function () {
		this.renderData = {};
	},
	mapRecenter: function () {
		this.map.setCenter(this.myLatLng);
	},
	afterRender: function () {
		let address = PJQ.app.session.project.get('address1') + ' ' + PJQ.app.session.project.get('city') + ', ' + PJQ.app.session.project.get('state') + ' ' + PJQ.app.session.project.get('zip'),
			markerTitle = PJQ.app.session.project.get('projectName'),
			geocoder = new google.maps.Geocoder();

		this.map = new google.maps.Map(document.getElementById('map_canvas'), mapOptions);


		address = address.trim();
		geocoder.geocode({
			'address': address
		}, _.bind(function (results, status) {
			if (status == google.maps.GeocoderStatus.OK) {
				this.map.setCenter(results[0].geometry.location);
				this.myLatLng = results[0].geometry.location;
				let marker = new google.maps.Marker({
					map: this.map,
					title: markerTitle,
					position: results[0].geometry.location
				});
			} else {
				alert("Unable to find Project Location for the following reason: " + status);
			}
		}, this));

		this.map.getStreetView().setVisible(false);
		this.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
		this.map.setZoom(15);
		this.map.setCenter(this.myLatLng);
	},
});


PJQ.views.projects.ProjectScopes = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Project-Scopes')
	},
	events: {},
	beforeFirstRender: function () {

		this.collection = new PJQ.collections.projects.Scopes(null, {
			project: PJQ.app.session.project
		});
		this.listenTo(this.collection, 'sync', this.render);
		this.collection.fetch();
	},
	beforeRender: function () {
		this.renderData = {
			scopes: this.collection.models
		};
	},
	afterRender: function () {
	}
});
